import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useWorkspaceSettingsStore } from "../../store/useWorkspaceSettingsStore";

import { MembersDialog } from "./MembersDialog";
import { SettingsCard } from "./SettingsCard";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

export const MembersCard = () => {
  const { t } = useTranslation(["workspaces"]);
  const { settings } = useWorkspaceSettingsStore();
  const [isMembersDialogOpen, setIsMembersDialogOpen] = useState(false);

  if (!settings) return null;

  const { members } = settings;

  const activeMembers = members.filter((member) => !member.left_at && !member.blocked_at);

  const action = (
    <div className="flex items-center space-x-2">
      <div className="flex -space-x-1">
        {activeMembers.slice(0, 3).map((member) => (
          <Avatar key={member.id} className="border-background h-5 w-5 border">
            <AvatarImage alt={member.full_name} src={member.avatar_path || member.avatar} />
            <AvatarFallback className="text-xs">
              {member.full_name
                .split(" ")
                .map((n) => n[0])
                .join("")}
            </AvatarFallback>
          </Avatar>
        ))}
        {activeMembers.length > 3 && (
          <div className="bg-muted flex h-5 w-5 items-center justify-center rounded-full text-xs font-medium">
            +{activeMembers.length - 3}
          </div>
        )}
      </div>
      <Badge className="text-xs" variant="outline">
        {members.length}
      </Badge>
    </div>
  );

  return (
    <>
      <button
        className="w-full cursor-pointer text-left"
        type="button"
        onClick={() => setIsMembersDialogOpen(true)}
      >
        <SettingsCard
          action={action}
          bottomCircle="from-violet-600 to-pink-500"
          bottomCirclePlacement="bottom-left"
          bottomCircleSize="h-16 w-16"
          description={t("workspaces:settings.members.description", {
            defaultValue: "{{count}} active member",
            count: activeMembers.length,
          })}
          icon="mdi:account-multiple"
          title={t("workspaces:settings.members.title", { defaultValue: "Members" })}
          topCircle="from-indigo-600 to-purple-500"
          topCirclePlacement="top-right"
          topCircleSize="h-24 w-24"
        />
      </button>

      <MembersDialog isOpen={isMembersDialogOpen} onClose={() => setIsMembersDialogOpen(false)} />
    </>
  );
};
